import Vue from 'vue';

const SET_TOTAL_MESSAGES = (state, totalMessages) => {
  state.totalMessages = totalMessages;
};

const SET_PAGE = (state, page) => {
  state.page = page;
};

const SET_MESSAGE = (state, message) => {
  const index = state.messages.findIndex(m => m.id === message.id);
  state.messages[index] = message;
};

const SET_MESSAGES = (state, messages) => {
  state.messages = messages;
};

const SET_MESSAGE_TO_BE_EDITED = (state, message) => {
  state.messageToBeEdited = message;
};

const SET_MESSAGE_THAT_IS_BEING_EDITED = (state, message) => {
  state.messageThatIsBeingEdited = message;
};

const SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE = (state, data) => {
  const attribute = data[0];
  const value = data[1];
  Vue.set(state.messageThatIsBeingEdited, attribute, value);
};

const SET_MODAL_IS_SHOWN = (state, isShown) => {
  state.modalIsShown = isShown;
};

const SET_STANDALONE_CONTENT = (state, content) => {
  state.standaloneContent = content;
};

const SET_FORM = (state, form) => {
  state.form = form;
};

const SET_LIVE = (state, live) => {
  state.live = live;
};

export default {
  SET_TOTAL_MESSAGES,
  SET_PAGE,
  SET_MESSAGE,
  SET_MESSAGES,
  SET_MESSAGE_TO_BE_EDITED,
  SET_MODAL_IS_SHOWN,
  SET_MESSAGE_THAT_IS_BEING_EDITED,
  SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE,
  SET_STANDALONE_CONTENT,
  SET_FORM,
  SET_LIVE,
};
